export const user = {
  name: "Dev Tamakuwala",
  location: "Surat, Gujarat",
  availability: "Ready to relocate",
  avatar: "MyPhoto.png",
  titles: [
    "Software Engineer",
    "Flutter Developer",
    "Spring Boot Developer",
    "REST API Developer",
    "Full Stack Developer",
  ],
  bio: "A results-driven Flutter and Spring Boot developer experienced in building scalable and secure mobile and backend applications. I work across cross-platform apps, REST APIs, cloud-backed systems, and real-time workflows, and I use AI-assisted tooling to accelerate delivery without compromising code quality.",
  social: {
    github: "https://github.com/DevTamakuwala",
    linkedin: "https://www.linkedin.com/in/devtamakuwala/",
    email: "mailto:dev.official2424@gmail.com",
    whatsapp: "https://wa.me/919016204659",
    website: "https://devtamakuwala.in",
  },
  languages: ["English", "Hindi", "Gujarati"],
};

export const resumeHighlights = [
  {
    label: "Core stack",
    value: "Spring Boot, REST APIs, Firebase, MySQL, PostgreSQL, Flutter",
  },
  {
    label: "Experience",
    value: "Software Developer Intern, Flutter team lead",
  },
  {
    label: "Languages",
    value: "English, Hindi, Gujarati",
  },
];

export const journeyData = [
  {
    type: "education",
    title: "Masters of Computer Application",
    company: "MIT World Peace University",
    location: "Pune, Maharashtra",
    date: "Aug 2024 - Jul 2026",
    details: ["CGPA: 8.52"],
  },
  {
    type: "education",
    title: "Bachelor of Computer Application",
    company: "C. B. Patel Computer College (VNSGU)",
    location: "Surat, Gujarat",
    date: "Aug 2021 - Jul 2024",
    details: ["CGPA: 8.36"],
  },
];

export const skillsData = [
  { name: "Flutter", level: 95, category: "Frameworks" },
  { name: "Spring Boot", level: 80, category: "Frameworks" },
  { name: "React.js", level: 75, category: "Frameworks" },
  { name: "Java", level: 90, category: "Languages" },
  { name: "Dart", level: 95, category: "Languages" },
  { name: "REST APIs", level: 90, category: "Languages" },
  { name: "Firebase", level: 90, category: "Databases" },
  { name: "MySQL", level: 75, category: "Databases" },
  { name: "PostgreSQL", level: 75, category: "Databases" },
  { name: "Azure", level: 70, category: "Tools" },
  { name: "Postman", level: 85, category: "Tools" },
  { name: "Git & GitHub", level: 90, category: "Tools" },
  { name: "IntelliJ IDEA", level: 90, category: "Tools" },
  { name: "Android Studio", level: 90, category: "Tools" },
  { name: "VS Code", level: 80, category: "Tools" },
];

export const projectsData = [
  {
    name: "Daily Dine Pro",
    description:
      "A full-stack mess management system to automate meal subscriptions and tracking for college messes. Features include QR-based meal validation, Firebase authentication for multiple roles, real-time admin analytics, and a secure RESTful backend.",
    tags: ["Flutter", "Spring Boot", "Firebase", "MySQL", "REST APIs"],
    category: ["Mobile", "Web"],
    link: "",
    github: true,
    githubLink: "https://devtamakuwala.github.io/daily-dine-pro-full-project/",
    startDate: "Aug 2025",
    endDate: "Dec 2025",
  },
  {
    name: "Business Sehyogi",
    description:
      "A platform connecting aspiring entrepreneurs, reducing networking time by 20% to 30%. Built as a scalable system for collaboration and long-term maintainability.",
    tags: ["Flutter", "Spring Boot", "MySQL"],
    category: ["Web", "Mobile"],
    link: "#",
    github: true,
    githubLink: "https://github.com/DevTamakuwala/BusinessSehyogiFullProject",
    startDate: "Jan 2024",
    endDate: "Apr 2024",
  },
  {
    name: "Arogya Sair",
    description:
      "Led the development of a mobile app that streamlined medical appointment booking, reducing patient wait times by 30%. Built a real-time platform with hospital search, appointment scheduling, and live status updates.",
    tags: ["Flutter", "Firebase"],
    category: ["Web", "Mobile"],
    link: "https://appetize.io/app/b_vmpbr36cosojks4geo3zbcfg3a?device=pixel7&osVersion=13.0&toolbar=true",
    demo: true,
    github: true,
    githubLink:
      "https://github.com/DevTamakuwala/Arogya-Sair-Flutter-Application",
    startDate: "Jun 2023",
    endDate: "Aug 2023",
  },
];

export const Workexperience = [
  {
    name: "Intellect Computers",
    role: "Full stack developer",
    location: "Surat, Gujarat",
    description:
      "Developed and deployed the institute's official website and currently building a cross-platform mobile application with backend services. The work includes scalable API design, deployment workflows, and collaboration with stakeholders.",
    highlights: [
      "Developed and deployed the institute's official website.",
      "Building a cross-platform mobile application using Flutter and FastAPI.",
      "Designing scalable APIs, backend architecture, and deployment workflows.",
    ],
    tags: ["Flutter", "FastAPI", "Deployment", "APIs"],
    category: ["Mobile", "Web"],
    startDate: "Jan 2026",
    endDate: "Present",
  },
  {
    name: "ByteCraft Studios",
    role: "Flutter Developer intern",
    location: "Pune, Maharashtra",
    description:
      "Developing Artsays, a Flutter-based cross-platform mobile application for artists to sell artwork and build an online community platform.",
    highlights: [
      "Implementing marketplace and community features supporting multiple user roles.",
      "Building responsive UI and integrating APIs and backend services.",
      "Reviewing and improving existing website and backend systems with debugging and performance optimization.",
    ],
    tags: ["Flutter", "UI/UX", "APIs", "Testing"],
    category: ["Mobile", "Web"],
    startDate: "Jan 2026",
    endDate: "July 2026",
  },
  {
    name: "MIT World Peace University",
    role: "Flutter Team Lead",
    location: "Pune, Maharashtra",
    description:
      "Led the Flutter development team to build WPU Immersions, a cross-platform mobile application with offline-first architecture and scalable design.",
    highlights: [
      "Designed and implemented responsive UI/UX across devices and network conditions.",
      "Integrated RESTful APIs and coordinated data synchronization with the backend team.",
      "Optimized application performance using efficient state management and code reviews.",
      "Delivered WPU Immersions application as internship proof-of-work, now live on Play Store and App Store.",
    ],
    proofLinks: [
      {
        label: "View MIT WPU Internship Proof Of Work",
        url: "/pow_mitwpu_dev_tamakuwala.pdf",
      },
      {
        label: "WPU Immersions on Play Store",
        url: "https://play.google.com/store/apps/details?id=com.mitwpu.immersions&pcampaignid=web_share",
      },
      {
        label: "WPU Immersions on App Store",
        url: "https://apps.apple.com/in/app/wpu-immersions/id6758524763",
      },
    ],
    tags: ["Flutter", "Offline-first", "REST APIs", "State Management"],
    category: ["Mobile"],
    startDate: "Jul 2025",
    endDate: "Dec 2025",
  },
];

export const certificates = [
  {
    name: "Master Microservices with Spring Boot and Spring Cloud Specialization",
    platform: "Coursera",
    url: "https://www.coursera.org/specializations/packt-master-microservices-with-spring-boot-and-spring-cloud",
    pdf: "/coursera_master_spring.pdf"
  },
  {
    name: "Foundations of Microservices and REST APIs with Spring Boot",
    platform: "Coursera",
    url: "https://www.coursera.org/learn/packt-foundations-of-microservices-and-rest-apis-with-spring-boot-drlce",
    pdf: "/coursera_spring-microservice.pdf",
  },
  {
    name: "Advanced Spring Cloud Microservices & Deployment with Docker",
    platform: "Coursera",
    url: "https://www.coursera.org/learn/packt-advanced-spring-cloud-microservices-and-deployment-with-docker-1nbvc",
    pdf: "/coursera_advance_spring.pdf"
  },
  {
    name: "Spring, JPA, Testing, and Legacy Microservices",
    platform: "Coursera",
    url: "https://www.coursera.org/learn/packt-spring-jpa-testing-and-legacy-microservices-jvjhr",
    pdf: "coursera_spring_test.pdf"
  },
  {
    name: "Flutter and Dart: Developing iOS, Android, and Mobile Apps",
    platform: "Coursera",
    note: "Passed with 92.95%",
    url: "https://coursera.org/share/d1bebe47735a33e4ae6db13bc8fa5a9b",
    pdf: "/coursera_flutter.pdf",
  },
  {
    name: "React Native by Meta",
    platform: "Coursera",
    url: "https://coursera.org/share/9636cfc4e54abf8b2d4aa5f9906e4cef",
    pdf: "/coursera_react_native.pdf",
  },
  {
    name: "Postman API Fundamentals Student Expert",
    platform: "Postman",
    url: "https://badges.parchment.com/public/assertions/KV0PKt-JR_Sv-5Baex2yUw",
    pdf: "/certificate-3iwtoq3eaar7-1774094630.pdf",
  },
  {
    name: "Java Data Structures & Algorithms + LeetCode Exercises",
    platform: "Udemy",
    url: "https://www.udemy.com/certificate/UC-55d8acff-9ce0-417e-8992-dd4b47e57604/",
    pdf: "/java+leetcode.pdf",
  },
];

// export const ongoingCertificates = [
// {
//   name: "Master Java, Spring Boot, Spring Security, Spring AI, Docker and Microservices",
//   platform: "Udemy",
//   url: "https://www.udemy.com/course/spring-5-with-spring-boot-2/?couponCode=ACCAGE0923",
// },
// {
//   name: "Master Microservices with Spring Boot and Spring Cloud Specialization",
//   platform: "Coursera",
//   url: "https://www.coursera.org/specializations/packt-master-microservices-with-spring-boot-and-spring-cloud",
// },
// ];